export const GET_STUDENT_SELECTION = 'GET_STUDENT_SELECTION';
export const SET_MULTIPLE_STUDENT_SELECTION_CRITERIA = 'SET_MULTIPLE_STUDENT_SELECTION_CRITERIA';
export const GET_CRITERIA = 'GET_CRITERIA';
export const SET_PRINT_CRITERIA = 'SET_PRINT_CRITERIA';
export const RESET = 'RESET';

